/* Static version of contacts store model */
export const state = () => ({
  cities: {
    loaded: true,
    items: [
      { id: 'agk', title: 'Ангарск' },
      { id: 'arc', title: 'Архангельск' },
      { id: 'ash', title: 'Астрахань' },
      { id: 'brk', title: 'Брянск' },
      { id: 'vng', title: 'Великий Новгород' },
      { id: 'vvk', title: 'Владвосток' },
      { id: 'vld', title: 'Владимир' },
      { id: 'vrz', title: 'Воронеж' },
      { id: 'ekb', title: 'Екатеринбург' },
      { id: 'msk', title: 'Москва' },
      { id: 'nsk', title: 'Новосибирск' },
      { id: 'spb', title: 'Санкт-Петербург' },
      { id: 'oms', title: 'Омск' },
      { id: 'orl', title: 'Орёл' },
    ],
  },
  office: {
    loaded: true,
    single: {
      id: 550,
      title: 'Москва',
      coords: { lat: 55.709504, lng: 37.351428 },
      email: 'info@russoutdoor.ru',
      address: '143421, Московская область, Красногорский район, 26-й км автодороги "Балтия", Бизнес-центр Riga Land, строение 1',
      phone: 'тел.: +7 (495) 626-52-00<br/>факс: +7 (495) 626-52-01',
      time: "09:00 - 18:00",
      reach: 'Добраться на машине',
    },
  },
  warehouse: {
    loaded: true,
    single: null,
  },
});

export const actions = {
  /* Load city list
  * */
  loadCities({ commit, dispatch, state }) {
    console.log('load STATIC version of cities');
  },
  /* Load office */
  loadOffice({ commit, dispatch, state }, { id }) {
    console.log('load STATIC version of office, id = ', id);
  },
};



// WEBPACK FOOTER //
// ./store/static/contacts.js